import {
  Box,
  Card,
  CardContent,
  Divider,
  Grid,
  Link as MuiLink,
  makeStyles,
  Switch,
  TextField,
  Theme,
  Typography,
  Paper,
} from "@material-ui/core";
import Backdrop from "@material-ui/core/Backdrop";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import IconButton from "@material-ui/core/IconButton";
import { PrintSharp, Close } from "@material-ui/icons";
import DeleteIcon from "@material-ui/icons/Delete";
import EditIcon from "@material-ui/icons/Edit";
import { GridRowModel } from "@mui/x-data-grid-pro";
import { useFormik } from "formik";
import moment from "moment";
import "moment-timezone";
import React, { useEffect, useRef, useState } from "react";
import { useDropzone } from "react-dropzone";
import { useDispatch } from "react-redux";
import { Prompt } from "react-router-dom";
import { fetchWrapper } from "src/api-client/fetchWrapper";
import { getPrintFile, searchData } from "src/app-redux/common-actions";
import { getAllFileCompressionConfigs } from "src/app-redux/configuration/actions/configurationActions";
import { useAppSelector } from "src/app-redux/hooks";
import {
  deleteNodVehicleInspectionWeight,
  getLocationAtTerminal,
} from "src/app-redux/vehicle/actions/vehicleActions";
import {
  loader as vehicleLoader,
  setSelectedVehicleWeightId,
} from "src/app-redux/vehicle/vehicleSlice";
import { filteryByArr } from "src/common/utils/app.dropdowns";
import TransitionDialog from "src/components/AlertDialog/TransitionDialog";
import CommonAutoCompleteField from "src/components/CommonAutoCompleteField/CommonAutoCompleteField";
import CommonButton from "src/components/CommonButton/CommonButton";
import NewCommonButton from "src/components/CommonButton/NewCommonButton";
import CommonTextFieldDate from "src/components/CommonTextFieldForDate/CommonTextFieldDate";

import TabHeader from "src/components/TabHeader/TabHeader";
import * as Yup from "yup";
import { VehicleManagementRoute } from "../../vehicle-management.routes";
import { columns } from "./components/columns";
import Drawer from "./components/Drawer";
import { loader as gateEntryLoader } from "src/app-redux/gate-entry/gateEntrySlice";
import { Tooltip } from "@mui/material";
import { filterBy } from "src/common/utils/helpers";
import { addNotificationAction } from "src/app-redux/settings/settingsSlice";
import DuplicateReceiptDialog from "src/components/AlertDialog/DuplicateReceiptDialog";
import CommonMaterialGridMultiSelect from "src/components/CommonXGrid/CommonMaterialGridMultiSelect";
import CommonLoader from "src/components/Loader/CommonLoader";

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    flexGrow: 1,
    display: "flex",
    minHeight: 500,
    "& .MuiDataGrid-columnHeaderWrapper": {
      backgroundColor: theme.palette.primary.light,
      color: theme.palette.primary.contrastText,
    },
    "& .MuiDataGrid-columnHeaderWrapper .MuiIconButton-label svg": { color: "rgba(255,255,255,1)" },
  },
  cardMain: {
    marginBottom: "0px",
    paddingTop: "2px",
    width: "calc(100%)",
  },
  pageHeading: {
    fontSize: theme.typography.pxToRem(20),
    fontWeight: theme.typography.fontWeightRegular,
    color: "#000",
  },
  breadcrumbs: {
    fontSize: theme.typography.pxToRem(12),
  },
  button: {
    margin: theme.spacing(1),
  },
  hideDatesGrid: {
    display: "none",
  },
  backdrop: {
    zIndex: theme.zIndex.modal + 1,
    color: "#fff",
  },
  readOnyTitle: {
    fontWeight: "bold",
  },
  multiselectConfigFileCompression: {
    position: "relative",
    paddingLeft: "4px",
    "& .searchWrapper": {
      border: "none",
      maxHeight: "35px",
      overflow: "auto",
    },
    "& ::placeholder": {
      color: "#bcbcbc",
    },
  },
}));

interface Props {}

export function InspectionWeight({}: Props): React.ReactElement {
  const [containerNumberList, setContainerNumberList] = React.useState<any>([]);
  const [containerSize, setContainerSize] = React.useState<string>("");

  const classes = useStyles();
  const [displayColumns, setDisplayColumns] = React.useState<any>(columns);
  const moduleName = VehicleManagementRoute.title;
  const [vehicleRecord, setvehicleRecord] = React.useState<GridRowModel[]>([]);
  const pageHeading = "Vehicle Inspection Weight";
  const [loader, setLoader] = useState<any>(false);
  const loader2: any = useAppSelector(vehicleLoader);
  const [isEditMode, setisEditMode] = React.useState(false);

  const [isCustomDate, setIsCustomDate] = useState<boolean>(false);
  const dispatch = useDispatch();
  const [vehicleRegNumberArr, setvehicleRegNumberArr] = React.useState<any[]>([]);
  const [isDrawerOpen, setisDrawerOpen] = React.useState(false);
  const receiptLoader: any = useAppSelector(gateEntryLoader);

  const handleCloseDrawer = () => {
    setisDrawerOpen(false);
  };
  const startDatePickerRef: any = useRef(null);
  const endDatePickerRef: any = useRef(null);

  const [fileToUpload, setFileToUpload] = React.useState<any[]>([]);
  const [validFileTypes, setValidFileTypes] = React.useState<any>([]);
  const [validFileSize, setValidFileSize] = React.useState(0);
  const [isValidFileType, setIsValidFileType] = React.useState<boolean[]>([]);
  const [isValidFileSize, setIsValidFileSize] = React.useState<boolean[]>([]);
  let fileTypesArr: any[] = [];
  let maxFileSize = 0;
  const [minWeightValue, setMinWeightValue] = useState<any>(0);
  const [deleteRemarks, setDeleteRemarks] = useState("");
  const [isDeleteMode, setIsDeleteMode] = React.useState(false);
  const terminalType = Number(localStorage.getItem("terminalType"));

  const onDrop = React.useCallback((acceptedFiles: File[]) => {
    const size: boolean[] = [];
    const type: boolean[] = [];

    acceptedFiles.forEach((file: any) => {
      const split = file.name.split(".");
      type.push(fileTypesArr.includes(`.${split[split.length - 1]}`.toLowerCase()));
      size.push(file.size / (1024 * 1024) <= maxFileSize);
    });

    setIsValidFileSize(size);
    setIsValidFileType(type);
    setFileToUpload(acceptedFiles);
  }, []);
  const { getRootProps, getInputProps, isDragActive } = useDropzone({ onDrop });

  const getFileConfig = async () => {
    const res: any = await dispatch(getAllFileCompressionConfigs());
    if (res.payload && res.payload[0]) {
      setValidFileTypes(res.payload[0].fileTypes.split(","));
      setValidFileSize(res.payload[0].fileSizeThreshold);
      fileTypesArr = res.payload[0].fileTypes.split(",");
      maxFileSize = res.payload[0].fileSizeThreshold;
    }
  };

  const validationSchema: any = Yup.object().shape({
    containerListField: Yup.array().of(
      Yup.object().shape({
        containerNumber: Yup.string(),
        weight: Yup.number(),
        tareWeight: Yup.number(),
      })
    ),
    vehicleId: Yup.string()
      .required("This field is required")
      .max(50, "Maximum 50 characters allowed"),
    refNum: Yup.string().max(50, "Maximum 50  characters allowed"),
    comment: Yup.string().max(3000, "Maximum 3000 characters allowed"),
    grossWeight: Yup.number()
      .required("This field is required")
      .min(minWeightValue, `Minimum ${minWeightValue} is allowed.`)
      .max(10000000000, "Maximum 10 digits allowed"),
    vehicleWeight: Yup.number()
      .required("This field is required")
      .max(10000000000, "Maximum 10 digits allowed"),
  });
  const formik = useFormik<any>({
    initialValues: {
      InProgressVehiclesDataOnly: false,
      filterBy: "today",
      startDate: moment(new Date(new Date().setDate(new Date().getDate())).setHours(0, 0)).format(
        "YYYY-MM-DDTHH:mm"
      ),
      endDate: moment(new Date(new Date().setDate(new Date().getDate())).setHours(23, 59)).format(
        "YYYY-MM-DDTHH:mm"
      ),
      containerListField: [{ containerNumber: "", weight: "", gatePassId: "", tareWeight: "" }],
      grossWeight: "",
      vehicleList: {},
      registrationNumber: "",
      vehicleWeightId: 0,
      terminalLocationId: "",
      vehicleId: "",
      vehicleStatusId: "",
      refNum: "",
      comment: "",
      vehicleWeight: "",
      weightUnit: "KG",
      entryDateTime: "",
      startTime: moment().format("YYYY-MM-DDTHH:mm:ss"),
      endTime: moment().format("YYYY-MM-DDTHH:mm:ss"),
    },
    validationSchema: validationSchema,
    onSubmit: async (values: any, actions) => {
      if (values.vehicleId == "") {
        dispatch(
          addNotificationAction({
            message: "Select vehicle number first!",
            options: { variant: "error" },
          })
        );
        return;
      }
      setLoader(true);
      const isLooseCargo = formik.values?.vehicleList?.consignmentType
        ?.includes("Loose Cargo")
        .toString();
      const netWeight = (values.vehicleWeight && values.grossWeight - values.vehicleWeight) || 0;
      const form = new FormData();
      form.append("containersList", JSON.stringify(values.containerListField));
      form.append("grossWeight", values.grossWeight);
      form.append("terminalLocationId", values.terminalLocationId);
      form.append("vehicleStatusId", values.vehicleStatusId);
      form.append("vehicleId", values.vehicleId);
      form.append("registrationNumber", values.registrationNumber);
      form.append("refNum", values.refNum);
      form.append("comment", values.comment);
      form.append("vehicleWeight", values.vehicleWeight);
      form.append("netWeight", netWeight);
      form.append("weightUnit", values.weightUnit);
      form.append("isLooseCargo", isLooseCargo);
      form.append("isEditMode", isEditMode.toString() || "false");

      fileToUpload.length
        ? fileToUpload.forEach((file) => {
            form.append("files", file);
          })
        : form.append("files", "");

      form.append("startTime", values.startTime);
      form.append("endTime", moment().format("YYYY-MM-DDTHH:mm:ss"));
      await fetchWrapper.post("/create-nod-vehicle-weight", form);
      handleSearch();
      getVehicleNumbers();
      actions.setSubmitting(false);
      actions.resetForm();
      setFileToUpload([]);
      setIsValidFileType([]);
      setIsValidFileSize([]);
      setIsDirty(false);
      getLocations();
      setContainerNumberList([]);
      setContainerSize("");
      resetSearch();

      setLoader(false);
    },
  });
  const { values, setValues } = formik;

  const addSerialNumber = async (rows: any) => {
    const transformedData = await rows?.map((row: any, index: number) => ({
      ...row,
      id: index,
      serialNumber: index + 1,
    }));
    return transformedData;
  };

  const handleSearch = async () => {
    const { filterBy, startDate, endDate, InProgressVehiclesDataOnly } = values;
    const body = {
      filterBy: filterBy || null,
      startDate: startDate || null,
      endDate: endDate || null,
      InProgressVehiclesDataOnly: InProgressVehiclesDataOnly || false,
    };
    setvehicleRecord([]);
    setLoader(true);
    try {
      const results: any = await dispatch(
        searchData("/get-all-nod-vehicle-weights", JSON.stringify(body))
      );
      if (results) {
        const record = await addSerialNumber(results.weightModel);
        setvehicleRecord(record);
      }
    } catch (error) {
      setLoader(false);
    }
    setLoader(false);
  };
  const resetSearch = () => {
    setisEditMode(false);
    setValues({ ...formik.initialValues, terminalLocationId: values.terminalLocationId });
    setIsDirty(false);
    setFileToUpload([]);
    setMinWeightValue(0);
    setContainerNumberList([]);
    setContainerSize("");
    formik.setFieldValue("vehicleWeight", "");
    formik.setFieldValue("grossWeight", "");
  };
  const resetGrid = () => {
    setValues({
      ...formik.values,
      InProgressVehiclesDataOnly: formik.initialValues.InProgressVehiclesDataOnly,
      filterBy: formik.initialValues.filterBy,
      startDate: formik.initialValues.startDate,
      endDate: formik.initialValues.endDate,
    });
    setIsCustomDate(false);
  };

  const getLocations = async () => {
    const res: any = await dispatch(getLocationAtTerminal());
    formik.setFieldValue(
      "terminalLocationId",
      res?.payload?.find((st: any) => st.name === "Weighbridge")?.id
    );
  };
  const filterByAction = (data: any) => {
    formik.setFieldValue("filterBy", data.value);
    if (data && data.value) {
      const res = filterBy(data);
      if (res?.isCustomDate) {
        setIsCustomDate(true);
        formik.setFieldValue("startDateCustom", res?.startDate);
        formik.setFieldValue("endDateCustom", res?.endDate);
      } else {
        setIsCustomDate(false);
      }
      formik.setFieldValue("startDate", res?.startDate);
      formik.setFieldValue("endDate", res?.endDate);
    }
  };
  const handleUpdateClick = (params: any) => {
    setMinWeightValue(Number(params.weight));

    const modifyContainerList =
      !params?.vehicleConsignmentType.includes("Loose Cargo") &&
      params?.containerWeightModel &&
      params?.containerWeightModel?.map((data: any, index: number) => {
        formik.setFieldValue(`containerListField.${index}.containerNumber`, data.containerNumber);
        formik.setFieldValue(`containerListField.${index}.gatePassId`, data.gatePassId);
        formik.setFieldValue(`containerListField.${index}.tareWeight`, data.tareWeight);
        formik.setFieldValue(`containerListField.${index}.weight`, data.containerTotalWeight);
        return {
          containerNumber: data?.containerNumber,
          gatePassId: data?.gatePassId,
          tareWeight: data?.tareWeight,
          weight: data?.containerTotalWeight,
        };
      });

    const modifyVehicleList = {
      consignmentType: params?.vehicleConsignmentType || "",
      vehicleType: params?.vehicleType || "",
      vehicleStatus: params?.vehicleStatus || "",
      gateEntryDate: params?.gateEntryDate || "",
      terminalLocation: params?.vehicleTerminalLocation || "",
    };

    setContainerNumberList(modifyContainerList || []);
    // Store containerSize from first container when editing
    if (
      modifyContainerList &&
      modifyContainerList.length > 0 &&
      params?.containerWeightModel &&
      params?.containerWeightModel[0]?.containerSize
    ) {
      setContainerSize(params.containerWeightModel[0].containerSize.toString());
    } else {
      setContainerSize("");
    }
    formik.setFieldValue("vehicleList", modifyVehicleList || "");

    setMinWeightValue(params?.vehicleWeight || 0);
    formik.setFieldValue("vehicleWeightId", params?.vehicleWeightId || 0);
    formik.setFieldValue("vehicleId", params?.vehicleId || 0);
    formik.setFieldValue("refNum", params?.refNum || "");
    formik.setFieldValue("comment", params?.remarks || "");
    formik.setFieldValue("vehicleWeight", params?.vehicleWeight || 0);
    formik.setFieldValue("grossWeight", params?.totalWeight || 0);
    formik.setFieldValue("weightUnit", params?.weightUnit || "KG");
    formik.setFieldValue("entryDateTime", params?.gateEntryTime || null);
    formik.setFieldValue("vehicleStatusId", params?.vehicleStatusId || 0);
    formik.setFieldValue("registrationNumber", params?.vehicleNumber || "");
    setisEditMode(true);
  };

  const [isOpenDeleteDailog, setIsOpenDeleteDailog] = useState<boolean>(false);
  const [deleteGridItem, setdeleteGridItem] = useState<any>("");
  const handleCloseDeleteDialog = () => {
    setIsDeleteMode(false);
    setDeleteRemarks("");
    setIsOpenDeleteDailog(false);
  };

  const handleDeleteDialog = async () => {
    setIsDeleteMode(true);
    if (deleteRemarks) {
      setIsOpenDeleteDailog(false);
      if (deleteGridItem) {
        const body = { deleteGridItem, deleteRemarks: deleteRemarks };

        const res: any = await dispatch(deleteNodVehicleInspectionWeight(body));
        if (res.payload) {
          setDeleteRemarks("");
          handleSearch();
          formik.resetForm();
          setFileToUpload([]);
          setIsValidFileType([]);
          setIsValidFileSize([]);
          setIsDirty(false);
          getLocations();
        }
      }
    }
  };

  const handleDelete = (list: any) => {
    setIsOpenDeleteDailog(true);
    setdeleteGridItem(list.vehicleId);
  };

  const weightSavehandler = () => {
    formik.submitForm();
  };

  const [isDirty, setIsDirty] = React.useState<boolean>(false);
  useEffect(() => {
    window.onbeforeunload = function (e: Event) {
      if (isDirty) {
        e.preventDefault();
        return "Changes you made may not be saved.";
      }
    };
  }, [isDirty]);
  function handleChange(e: any) {
    formik.handleChange(e);
    e.target.value || JSON.stringify(formik.values) !== JSON.stringify(formik.initialValues)
      ? setIsDirty(true)
      : setIsDirty(false);
  }

  const removeFileFromIndex = (index: number) => {
    const upload = fileToUpload;
    upload.splice(index, 1);
    setFileToUpload(upload);

    const size: boolean[] = [];
    const type: boolean[] = [];

    fileToUpload.forEach((file: any) => {
      const split = file.name.split(".");
      type.push(validFileTypes.includes(`.${split[split.length - 1]}`));
      size.push(file.size / (1024 * 1024) <= validFileSize);
    });

    setIsValidFileSize(size);
    setIsValidFileType(type);
  };

  const listener = (e: any) => {
    if (
      (e.key === "s" || e.key === "S") &&
      (navigator.platform.match("Mac") ? e.metaKey : e.ctrlKey)
    ) {
      e.preventDefault();
      if (!loader && !loader2) formik.submitForm();
    }
  };

  useEffect(() => {
    document.addEventListener("keydown", listener);
    return () => {
      document.removeEventListener("keydown", listener);
    };
  }, [loader, loader2]);

  const [isOpenPrintDailog, setIsOpenPrintDailog] = useState<boolean>(false);
  const [selectedRecordId, setSelectedRecordId] = useState(null);

  const printReceipt = async (isDuplicate: string) => {
    setIsOpenPrintDailog(false);
    const dateTime = moment().format("DD MMM YYYY, HH:mm ");
    const fileMetaData = {
      url: `${process.env.REACT_APP_API_URL}/get-weigh-bridge-slip-by-vehicle-id/${selectedRecordId}?isDuplicate=${isDuplicate}&printDateTime=${dateTime}`,
      contentType: ".pdf",
      fileName: "testPdf.pdf",
    };
    await dispatch(getPrintFile(fileMetaData, dispatch));
  };

  const exportHandler = async (row: any) => {
    dispatch(
      addNotificationAction({
        message: "Your download will begin shortly",
        options: { variant: "success" },
      })
    );
    const exportedRecords = await row?.map((data: any) => {
      return {
        "Serial #": data?.serialNumber,
        Vehicle: data?.vehicleId,
        Status: data?.vehicleStatus,
        Location: data?.terminalLocation,
        "Gross Weight": `${data?.grossWeight?.toLocaleString(undefined, {
          maximumFractionDigits: 2,
        })} ${data.weightUnit ? data.weightUnit : "KG"}`,
        Cargo: data?.cargoTypeName,
        Consignment: data?.consignmentTypeName,
        "Start Time": data.startTime ? moment(data.startTime).format("DD-MM-YYYY hh:mm:ss A") : "",
        "End Time": data.endTime ? moment(data.endTime).format("DD-MM-YYYY hh:mm:ss A") : "",
        "In Progress": data.vehicleInProgress ? "Yes" : "No",
        "Reference #": data?.refNum,
        Remarks: data?.remarks,
      };
    });
    return exportedRecords;
  };

  const getVehicleNumbers = async () => {
    const body = {
      filterBy: null,
      startDate: new Date(),
      endDate: null,
      InProgressVehiclesDataOnly: true,
    };
    setvehicleRegNumberArr([]);
    setLoader(true);
    try {
      const results: any = await fetchWrapper.post("/get-all-vehicles", body);
      if (results) {
        setvehicleRegNumberArr(results?.value || []);
      }
    } catch (error) {
      setLoader(false);
    }
    setLoader(false);
  };

  const getContainerNumbers = async (vehicleId: number | string) => {
    setContainerNumberList([]);
    setLoader(true);
    try {
      const results: any = await fetchWrapper.get(`get-all-containers-by-vehicle-id/${vehicleId}`);
      if (results) {
        const filterContainer = results?.value?.containerList.filter(
          (data: any) => data.containerNumber
        );

        filterContainer.map((data: any, index: number) => {
          formik.setFieldValue(`containerListField.${index}.containerNumber`, data.containerNumber);
          formik.setFieldValue(`containerListField.${index}.gatePassId`, data.gatePassId);
          formik.setFieldValue(`containerListField.${index}.weight`, data.weight);
          formik.setFieldValue(`containerListField.${index}.tareWeight`, data.tareWeight);
        });

        setContainerNumberList(filterContainer || []);
        // Store containerSize from first container (assuming all containers have the same size)
        if (filterContainer && filterContainer.length > 0 && filterContainer[0].containerSize) {
          setContainerSize(filterContainer[0].containerSize.toString());
        } else {
          setContainerSize("");
        }
      }
    } catch (error) {
      setLoader(false);
    }
    setLoader(false);
  };

  useEffect(() => {
    if (vehicleRecord.length) {
      const transformedColumns: any = columns.map((column: any) =>
        column.accessorKey === "remarks"
          ? {
              ...column,
              Cell: function customCell({ renderedCellValue }: any) {
                return (
                  <Tooltip title={renderedCellValue} followCursor>
                    <span>{renderedCellValue}</span>
                  </Tooltip>
                );
              },
            }
          : column.accessorKey === "serialNumber"
          ? {
              ...column,
              Cell: function customCell({ renderedCellValue }: any) {
                return <div>{renderedCellValue ? renderedCellValue : "--"}</div>;
              },
            }
          : column.accessorKey === "vehicleWeight"
          ? {
              ...column,
              Cell: function customCell({ row }: any) {
                return `${row.original.vehicleWeight.toLocaleString(undefined, {
                  maximumFractionDigits: 2,
                })} ${row.original.weightUnit ? row.original.weightUnit : "KG"}`;
              },
            }
          : column.accessorKey === "totalWeight"
          ? {
              ...column,
              Cell: function customCell({ row }: any) {
                return `${row.original.totalWeight.toLocaleString(undefined, {
                  maximumFractionDigits: 2,
                })} ${row.original.weightUnit ? row.original.weightUnit : "KG"}`;
              },
            }
          : column.accessorKey === "files"
          ? {
              ...column,
              Cell: function customCell({ row }: any) {
                return (
                  <MuiLink
                    className="customMuiLink"
                    onClick={() => {
                      dispatch(
                        setSelectedVehicleWeightId({
                          weightId: row.original.vehicleId,
                          regNo: row.original.vehicleNumber,
                          isNodWeightFile: true,
                        })
                      );
                      setisDrawerOpen(true);
                    }}
                  >
                    View
                  </MuiLink>
                );
              },
            }
          : column.accessorKey === "actions"
          ? {
              ...column,
              Cell: function customCell({ row }: any) {
                return (
                  <>
                    <NewCommonButton
                      onClick={() => {
                        setIsDirty(true);
                        handleUpdateClick(row.original);
                      }}
                      icon={<EditIcon />}
                      isEdit={true}
                    >
                      Edit
                    </NewCommonButton>
                    <NewCommonButton
                      onClick={() => {
                        handleDelete(row.original);
                      }}
                      icon={<DeleteIcon />}
                    >
                      Delete
                    </NewCommonButton>
                    <NewCommonButton
                      onClick={() => {
                        setSelectedRecordId(row.original?.vehicleId);
                        setIsOpenPrintDailog(true);
                      }}
                      icon={<PrintSharp />}
                      isGreen
                    >
                      Print
                    </NewCommonButton>
                  </>
                );
              },
            }
          : column
      );

      setDisplayColumns(transformedColumns);
    }
  }, [vehicleRecord]);

  useEffect(() => {
    handleSearch();
    getLocations();
    getVehicleNumbers();
    getFileConfig();
  }, []);

  return (
    <div>
      {/* If prompt, when navigating to another page inside the app */}
      <Prompt when={isDirty} message="Changes you made may not be saved." />
      <TabHeader module={moduleName} heading={pageHeading} link={VehicleManagementRoute.path} />
      <Backdrop className={classes.backdrop} open={loader || loader2 || receiptLoader}>
        <CommonLoader />
      </Backdrop>
      <Drawer
        isDrawerOpen={isDrawerOpen}
        handleCloseDrawer={() => {
          handleCloseDrawer();
        }}
      />

      {/* Dialog for Print Receipt */}
      <DuplicateReceiptDialog
        isOpen={isOpenPrintDailog}
        handleOriginal={() => {
          printReceipt("0");
        }}
        heading={"Confirmation"}
        handleDuplicate={() => {
          printReceipt("1");
        }}
        onClose={() => {
          setIsOpenPrintDailog(false);
        }}
      >
        Which receipt do you want to print?
      </DuplicateReceiptDialog>
      <Box m={2} />
      <Card>
        <CardContent className={classes.cardMain}>
          <Grid container direction="row" justifyContent="space-between" alignItems="center">
            <Grid item md={9}>
              <Box mt={1} mb={2}>
                <Typography className={classes.pageHeading}> {pageHeading} </Typography>
              </Box>
            </Grid>
            <Grid item xs={12} md={3}>
              <Box textAlign="right" mt={1} mb={1}>
                <CommonButton cssClass="customSubmitBtn" onClick={() => resetSearch()}>
                  Reset
                </CommonButton>
                <CommonButton
                  cssClass="customSubmitBtn"
                  isGreen
                  onClick={() => weightSavehandler()}
                >
                  {isEditMode ? "Update" : "Save"}
                </CommonButton>
              </Box>
            </Grid>
          </Grid>
          <Box style={{ marginBottom: "30px" }}>
            <Divider />
          </Box>
          <>
            <Grid spacing={2} container direction="row" justifyContent="space-between">
              <Grid item xs={12} md={8}>
                <Grid spacing={2} container direction="row">
                  <Grid item xs={12} md={4}>
                    <Box>
                      <CommonAutoCompleteField
                        cssClassName="customTextField"
                        label="Vehicle Number"
                        placeholder="Enter Vehicle Number"
                        name="vehicleId"
                        optionsType={vehicleRegNumberArr}
                        getOptionLabel={(option) => option.vehicleNumber || ""}
                        required
                        value={
                          vehicleRegNumberArr.find(
                            (st: any) => st.vehicleId === formik.values.vehicleId
                          ) || null
                        }
                        onChange={(option: any) => {
                          setMinWeightValue(0);
                          formik.resetForm();
                          resetSearch();
                          getContainerNumbers(option.vehicleId);
                          handleChange({ target: { value: option.vehicleId } });
                          formik.setFieldValue("vehicleStatusId", option.vehicleStatusId);
                          formik.setFieldValue("vehicleId", option.vehicleId);
                          formik.setFieldValue("registrationNumber", option.vehicleNumber);
                          formik.setFieldValue("vehicleList", option);

                          formik.setFieldValue("vehicleWeight", option.vehicleWeight || 0);
                          formik.setFieldValue("grossWeight", option.grossWeight || 0);
                          formik.setFieldValue("comment", option.comments || "");
                          formik.setFieldValue("refNum", option.refNum || "");
                          setMinWeightValue(option.vehicleWeight || 0);
                        }}
                        error={formik.touched.vehicleId && Boolean(formik.errors.vehicleId)}
                        helperText={formik.touched.vehicleId && formik.errors.vehicleId}
                      />
                    </Box>
                  </Grid>
                  <Grid item xs={12} md={4}>
                    <Box>
                      <TextField
                        required
                        className="customTextField"
                        type="number"
                        size="small"
                        fullWidth
                        variant="outlined"
                        InputLabelProps={{
                          shrink: true,
                        }}
                        label="Vehicle Weight"
                        name="vehicleWeight"
                        placeholder="Enter Vehicle Weight"
                        disabled={false}
                        value={formik.values.vehicleWeight}
                        onChange={(e) => {
                          handleChange(e);
                          setMinWeightValue(e.target.value);
                        }}
                        error={formik.touched.vehicleWeight && Boolean(formik.errors.vehicleWeight)}
                        helperText={formik.touched.vehicleWeight && formik.errors.vehicleWeight}
                      />
                    </Box>
                  </Grid>
                  <Grid item xs={12} md={4}>
                    <Box>
                      <TextField
                        required
                        className="customTextField"
                        size="small"
                        fullWidth
                        variant="outlined"
                        InputLabelProps={{
                          shrink: true,
                        }}
                        label="Gross Weight"
                        name="grossWeight"
                        placeholder="Enter Gross Weight"
                        disabled={false}
                        value={formik.values.grossWeight}
                        onChange={handleChange}
                        error={formik.touched.grossWeight && Boolean(formik.errors.grossWeight)}
                        helperText={formik.touched.grossWeight && formik.errors.grossWeight}
                      />
                    </Box>
                  </Grid>

                  {!formik.values?.vehicleList?.consignmentType?.includes("Loose Cargo") &&
                    containerNumberList &&
                    containerNumberList?.map((data: any, index: number) => (
                      <Grid spacing={1} container item xs={12} md={12} key={index}>
                        <Grid item xs={12} md={4}>
                          <Box>
                            <TextField
                              className="customTextField"
                              type="text"
                              size="small"
                              fullWidth
                              variant="outlined"
                              InputLabelProps={{
                                shrink: true,
                              }}
                              label={`Container Number ${index + 1}`}
                              name={`containerListField.${index}.containerNumber`}
                              placeholder="Enter Container Number"
                              disabled={true}
                              value={
                                formik.values.containerListField[index]?.containerNumber ||
                                data?.containerNumber ||
                                ""
                              }
                            />
                          </Box>
                        </Grid>
                        <Grid item xs={12} md={4}>
                          <Box style={{ marginLeft: "5px" }}>
                            <TextField
                              className="customTextField"
                              type="number"
                              size="small"
                              fullWidth
                              variant="outlined"
                              InputLabelProps={{
                                shrink: true,
                              }}
                              label={`Weight ${index + 1}`}
                              name={`containerListField.${index}.weight`}
                              placeholder="Enter Weight"
                              disabled={false}
                              value={formik.values.containerListField[index]?.weight || ""}
                              onChange={(e) => {
                                formik.setFieldValue(
                                  `containerListField.${index}.weight`,
                                  e.target.value
                                );
                              }}
                            />
                          </Box>
                        </Grid>
                        <Grid item xs={12} md={4}>
                          <Box style={{ marginLeft: "10px" }}>
                            <TextField
                              className="customTextField"
                              type="number"
                              size="small"
                              fullWidth
                              variant="outlined"
                              InputLabelProps={{
                                shrink: true,
                              }}
                              label={`Tare ${index + 1}`}
                              name={`containerListField.${index}.tareWeight`}
                              placeholder="Enter Tare Weight"
                              disabled={false}
                              value={formik.values.containerListField[index]?.tareWeight || ""}
                              onChange={(e) => {
                                formik.setFieldValue(
                                  `containerListField.${index}.tareWeight`,
                                  e.target.value
                                );
                              }}
                            />
                          </Box>
                        </Grid>
                      </Grid>
                    ))}

                  <Grid item xs={12} md={4}>
                    <Box>
                      <TextField
                        className="customTextField"
                        size="small"
                        fullWidth
                        variant="outlined"
                        InputLabelProps={{
                          shrink: true,
                        }}
                        label="Reference Number"
                        name="refNum"
                        placeholder="Enter Reference Number"
                        disabled={false}
                        value={formik.values.refNum}
                        onChange={handleChange}
                        error={formik.touched.refNum && Boolean(formik.errors.refNum)}
                        helperText={formik.touched.refNum && formik.errors.refNum}
                      />
                    </Box>
                  </Grid>
                  <Grid item xs={12} md={4}>
                    <Box
                      {...getRootProps()}
                      p={0}
                      pl={1}
                      border={"1px solid rgb(196 196 196)"}
                      borderRadius={5}
                      height={38}
                      pb={4}
                      overflow={"auto"}
                      display={"flex"}
                      flexWrap={"wrap"}
                      borderColor={isDragActive ? "error.main" : "rgb(196 196 196)"}
                    >
                      <input {...getInputProps()} />

                      {fileToUpload.length ? (
                        fileToUpload.map((file, index) => {
                          return (
                            <div
                              key={file.name}
                              style={{
                                marginTop: "6px",
                                backgroundColor: "#E67817",
                                padding: "3px 15px 3px 5px",
                                borderRadius: "10px",
                                maxWidth: "122px",
                                display: "flex",
                                flexWrap: "wrap",
                                marginLeft: "5px",
                              }}
                            >
                              <div
                                style={{
                                  maxWidth: "100px",
                                  whiteSpace: "nowrap",
                                  overflow: "hidden",
                                  textOverflow: "ellipsis",
                                  fontSize: "11px",
                                  color: "white",
                                }}
                              >
                                {file.name}
                              </div>
                              <IconButton
                                aria-label="Search"
                                onClick={(event) => {
                                  event.stopPropagation();
                                  removeFileFromIndex(index);
                                }}
                                edge="end"
                                className="icon-button-search"
                                style={{
                                  color: "white",
                                  padding: 0,
                                  marginTop: "2px",
                                  width: "10px",
                                  height: "10px",
                                  overflow: "hidden",
                                  marginRight: "2px !important",
                                }}
                              >
                                <Close />
                              </IconButton>
                            </div>
                          );
                        })
                      ) : isDragActive ? (
                        <p>Drop a file here ...</p>
                      ) : (
                        <p style={{ color: "black", marginTop: 9, paddingBottom: 10 }}>
                          {/* Drag and drop file here,or click to select a file */}
                          Upload File(s)
                        </p>
                      )}
                    </Box>
                    <Box>
                      <div style={{ color: "#f44336", marginBottom: 0 }}>
                        <ul
                          style={{
                            paddingLeft: "16px",
                            margin: 0,
                            display: isValidFileType.includes(false) ? "block" : "none",
                          }}
                        >
                          <li>
                            Only{" "}
                            {validFileTypes.map((type: any, index: number) => {
                              return index < validFileTypes.length - 1 ? `${type},` : type;
                            })}{" "}
                            files are allowed.
                          </li>
                        </ul>
                        <ul
                          style={{
                            paddingLeft: "16px",
                            margin: 0,
                            display: isValidFileSize.includes(false) ? "block" : "none",
                          }}
                        >
                          <li>File size cannot exceed {validFileSize}MB.</li>
                        </ul>
                      </div>
                    </Box>
                  </Grid>
                  <Grid item xs={12} md={4}>
                    <Box>
                      <TextField
                        multiline
                        rows={1}
                        rowsMax={3}
                        className="customTextField"
                        size="small"
                        fullWidth
                        variant="outlined"
                        InputLabelProps={{
                          shrink: true,
                        }}
                        label="Remarks"
                        name="comment"
                        placeholder="Enter Remarks"
                        disabled={false}
                        value={formik.values.comment}
                        onChange={handleChange}
                        error={formik.touched.comment && Boolean(formik.errors.comment)}
                        helperText={formik.touched.comment && formik.errors.comment}
                      />
                    </Box>
                  </Grid>
                </Grid>
              </Grid>
              <Grid item xs={12} md={4}>
                <Paper elevation={1} variant="outlined" style={{ padding: "15px" }}>
                  <Grid spacing={1} container direction="row" justifyContent="space-between">
                    {formik.values?.vehicleList?.consignmentType?.includes("Loose Cargo") && (
                      <>
                        <Grid item xs={5}>
                          <Typography className={classes.readOnyTitle}>Net Weight:</Typography>
                        </Grid>
                        <Grid item xs={7}>
                          <Typography>
                            {formik.values?.grossWeight - formik.values?.vehicleWeight >= 0
                              ? formik.values?.grossWeight - formik.values?.vehicleWeight
                              : "-"}
                          </Typography>
                        </Grid>
                      </>
                    )}
                    <Grid item xs={5}>
                      <Typography className={classes.readOnyTitle}>Vehicle Type:</Typography>
                    </Grid>
                    <Grid item xs={7}>
                      <Typography>{formik.values?.vehicleList?.vehicleType || "-"}</Typography>
                    </Grid>

                    <Grid item xs={5}>
                      <Typography className={classes.readOnyTitle}>Vehicle Status:</Typography>
                    </Grid>
                    <Grid item xs={7}>
                      <Typography>{formik.values?.vehicleList?.vehicleStatus || "-"}</Typography>
                    </Grid>

                    <Grid item xs={5}>
                      <Typography className={classes.readOnyTitle}>Vehicle Entry Date:</Typography>
                    </Grid>
                    <Grid item xs={7}>
                      <Typography>
                        {formik.values?.vehicleList?.gateEntryDate
                          ? moment(formik.values?.vehicleList?.gateEntryDate).format(
                              "DD-MM-YYYY hh:mm a"
                            ) || "-"
                          : formik.values?.vehicleList?.gateEntryDate || "-"}
                      </Typography>
                    </Grid>

                    {terminalType == 4 && (
                      <>
                        <Grid item xs={5}>
                          <Typography className={classes.readOnyTitle}>
                            Container Load Type:
                          </Typography>
                        </Grid>
                        <Grid item xs={7}>
                          <Typography>
                            {(() => {
                              const containerCount = containerNumberList?.length || 0;
                              if (!containerSize || containerCount === 0) return "-";
                              return `${containerCount}x${containerSize}`;
                            })()}
                          </Typography>
                        </Grid>
                      </>
                    )}

                    <Grid item xs={5}>
                      <Typography className={classes.readOnyTitle}>
                        Location at Terminal:
                      </Typography>
                    </Grid>
                    <Grid item xs={7}>
                      <Typography>{formik.values?.vehicleList?.terminalLocation || "-"}</Typography>
                    </Grid>

                    <Grid item xs={5}>
                      <Typography className={classes.readOnyTitle}>Type of Consignment:</Typography>
                    </Grid>
                    <Grid item xs={7}>
                      <Typography>{formik.values?.vehicleList?.consignmentType || "-"}</Typography>
                    </Grid>
                  </Grid>
                </Paper>
              </Grid>
            </Grid>
          </>
          <Box style={{ marginTop: "30px", marginBottom: "30px" }}>
            <Divider />
          </Box>
          <>
            <Grid spacing={2} container direction="row">
              <Grid item xs={12} md={3} lg={2}>
                <CommonAutoCompleteField
                  cssClassName="customTextField"
                  error={formik.touched.filterBy && Boolean(formik.errors.filterBy)}
                  helperText={formik.touched.filterBy && formik.errors.filterBy}
                  label="Filter by"
                  placeholder="Filter by"
                  name="filterBy"
                  disableClearable={true}
                  optionsType={filteryByArr}
                  getOptionLabel={(option: any) => option.label || ""}
                  onChange={(row: any) => {
                    row ? setValues({ ...values, filterBy: row.value || "" }) : "";
                    if (row === null) {
                      formik.setFieldValue("filterBy", null);
                    }
                    filterByAction(row);
                  }}
                  value={
                    filteryByArr.find(({ value }: any) => value === formik.values.filterBy) || ""
                  }
                />
              </Grid>
              <Grid
                item
                xs={12}
                md={3}
                lg={2}
                className={!isCustomDate ? classes.hideDatesGrid : ""}
              >
                <CommonTextFieldDate
                  cssClassName="customTextField"
                  label={"Start Date"}
                  name={"startDate"}
                  datePickerRef={startDatePickerRef}
                  value={formik.values.startDate}
                  onChange={(e: any) => {
                    formik.setFieldValue("startDate", moment(e).format("YYYY-MM-DDTHH:mm"));
                    formik.setFieldValue("endDate", "");
                  }}
                  maxDate={moment().format("YYYY-MM-DDTHH:mm")}
                />
              </Grid>
              <Grid
                item
                xs={12}
                md={3}
                lg={2}
                className={!isCustomDate ? classes.hideDatesGrid : ""}
              >
                <CommonTextFieldDate
                  cssClassName="customTextField"
                  label={"End Date"}
                  name={"endDate"}
                  datePickerRef={endDatePickerRef}
                  value={formik.values.endDate}
                  onChange={(e: any) => {
                    formik.setFieldValue("endDate", moment(e).format("YYYY-MM-DDTHH:mm"));
                  }}
                  minDate={formik.values.startDate}
                  maxDate={moment().format("YYYY-MM-DDTHH:mm")}
                />
              </Grid>
              <Grid item xs={12} md={isCustomDate ? 3 : 4} lg={2} style={{ paddingRight: 0 }}>
                <FormControlLabel
                  control={
                    <Switch
                      checked={Boolean(formik.values.InProgressVehiclesDataOnly)}
                      onChange={formik.handleChange}
                      name="InProgressVehiclesDataOnly"
                      color="primary"
                    />
                  }
                  label="In Progress Vehicles"
                />
              </Grid>
              <Grid item xs={12} md={isCustomDate ? 12 : 5} lg={isCustomDate ? 4 : 8}>
                <Box textAlign="right" mt={1} mb={1} style={{ float: "right" }}>
                  <CommonButton
                    cssClass="customSubmitBtn"
                    onClick={() => {
                      resetGrid();
                    }}
                  >
                    Reset
                  </CommonButton>
                  <CommonButton cssClass="customSubmitBtn" isGreen onClick={handleSearch}>
                    Search
                  </CommonButton>
                </Box>
              </Grid>
            </Grid>
          </>
          <div className="">
            <CommonMaterialGridMultiSelect
              rows={vehicleRecord}
              columns={displayColumns}
              defaultPerPageRecord={15}
              height={550}
              // isExport={isExport}
              exportHandler={exportHandler}
              filename={`Vehicle_insp_weight_${Date.now()}`}
            />
          </div>
        </CardContent>
      </Card>
      <TransitionDialog
        isOpen={isOpenDeleteDailog}
        handleClose={handleCloseDeleteDialog}
        heading={"Confirmation"}
        handleConfirm={handleDeleteDialog}
      >
        Are you sure you want to delete this record?
        <Box style={{ marginTop: "10px", marginBottom: "10px" }}>
          <TextField
            required
            multiline
            rows={1}
            rowsMax={5}
            size="small"
            fullWidth
            className="customTextField"
            variant="outlined"
            InputLabelProps={{
              shrink: true,
            }}
            label="Remarks"
            name="remarks"
            id="remarks"
            placeholder="Enter Remarks"
            disabled={false}
            value={deleteRemarks}
            onChange={(e) => {
              const { value } = e.target;
              setDeleteRemarks(value);
            }}
            error={isDeleteMode && !deleteRemarks}
            helperText={isDeleteMode && !deleteRemarks && "This field is required"}
          />
        </Box>
      </TransitionDialog>
    </div>
  );
}
